/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The custom placeholder for input of AccountSelect component
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { Fragment } from 'react';

import { icons } from '../../assets';
import { accountSelect } from '../../theme';
import { formatBalance } from '../../utils/formatText';
import { EllipseText } from '../common';
import { IAccountSelectItem } from './AccountSelectTypes';
import {
    AccountSelectDisplayContainerStyled,
    AccountSelectDisplayIconStyled,
    AccountSelectDisplayItemStyled,
    AccountSelectDisplayStyled,
    AccountSelectLoaderStyled,
} from './styled/AccountSelectStyled';

interface IAccountSelectDisplay {
    currency: string;
    defaultValue: string;
    disabled: boolean;
    isLoading: boolean;
    isValid?: boolean;
    selectedAccount: IAccountSelectItem;
}

export const AccountSelectDisplay = (props: IAccountSelectDisplay) => {
    const balance = `${formatBalance(props.selectedAccount.balance)} ${props.currency}`;
    return (
        <AccountSelectDisplayContainerStyled>
            <AccountSelectDisplayStyled
                disabled={props.disabled}
                isValid={props.isValid}
            >
                {
                    props.selectedAccount && props.selectedAccount.id ?
                        <Fragment>
                            <AccountSelectDisplayItemStyled
                                width={accountSelect.displayItemNumberWidth}
                            >
                                {props.selectedAccount.number}
                            </AccountSelectDisplayItemStyled>
                            <EllipseText
                                title={props.selectedAccount.name}
                                wrapper={AccountSelectDisplayItemStyled}
                                wrapperProps={{
                                    isColorSecondary: true,
                                }}
                            >
                                {props.selectedAccount.name || ''}
                            </EllipseText>
                            <EllipseText
                                title={balance}
                                wrapper={AccountSelectDisplayItemStyled}
                                wrapperProps={{
                                    isColorSecondary: true,
                                    textAlign: 'right',
                                    width: accountSelect.displayItemBalanceWidth,
                                }}
                            >
                                {balance}
                            </EllipseText>
                        </Fragment>
                        :
                        <AccountSelectDisplayItemStyled
                            isColorSecondary={true}
                        >
                            {props.defaultValue}
                        </AccountSelectDisplayItemStyled>
                }
                {
                    props.isLoading ?
                        <AccountSelectLoaderStyled/>
                        :
                        <AccountSelectDisplayIconStyled src={icons.arrowListDownMedium} />
                }
            </AccountSelectDisplayStyled>
        </AccountSelectDisplayContainerStyled>
    );
};

AccountSelectDisplay.defaultProps = {
    isValid: true,
};
